module.exports = __webpack_public_path__ + "static/media/ramez.3c343da8.webp";